import Image from 'next/image';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Container } from '../../components';
import styles from './keto-icons.module.css';
import KetoPaper from './keto-paper';
import KetoTypography, { KetoTypographyVariant } from './keto-typography';

export default function KetoIcons() {
  return (
    <section className={styles.icons}>
      <Container>
        <AnimationOnScroll
          offset={400}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInUp"
          className={styles.icons_inner}
        >
          <div className={styles.icons_start}>
            <KetoTypography
              className={styles.icons_title}
              tag="h2"
              variant={KetoTypographyVariant.HEADLINE_1}
            >
              Icons
            </KetoTypography>
            <KetoPaper>
              <KetoTypography
                className={styles.icons_text}
                variant={KetoTypographyVariant.BODY_2}
                tag="p"
              >
                The set of icons was painted to represent tabs, categories,
                tags, recipe complexity and timing.
              </KetoTypography>
            </KetoPaper>
          </div>
          <div className={styles.icons_end}>
            <Image
              src="/keto/icons-images/icons.png"
              width={661}
              height={482}
              alt="more icons"
            />
          </div>
          <img
            className={styles.carbs}
            src="/keto/icons/carbs.svg"
            alt="carbs"
          />
        </AnimationOnScroll>
      </Container>
    </section>
  );
}
